import { render, staticRenderFns } from "./EmptyView.vue?vue&type=template&id=2fd955db&scoped=true"
import script from "./EmptyView.vue?vue&type=script&lang=ts"
export * from "./EmptyView.vue?vue&type=script&lang=ts"
import style0 from "./EmptyView.vue?vue&type=style&index=0&id=2fd955db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd955db",
  null
  
)

export default component.exports